import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBiorhythmEmotionalIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 34C20 34 4 24.4706 4 15.25C4 10.6936 7.36842 7 12 7C14.4 7 16.8 7.79412 20 10.9706C23.2 7.79412 25.6 7 28 7C32.6315 7 36 10.6936 36 15.25C36 24.4706 20 34 20 34Z",
		stroke: "#FF537F",
		strokeWidth: 2.5,
		strokeLinejoin: "round"
	})
});
export default SvgBiorhythmEmotionalIcon;
